<template>
<div>
  <p class="sub-header">University of Southern California</p>
<!--  {{USC_classes}}-->
  <div class="classes-container">
    <div class="single_class"
        v-for="cls in USC_classes" :key="cls.index"
    >
      <span  v-html="cls.title"></span>
      <span  v-html="cls.description"></span>
    </div>
  </div>
  <p class="sub-header">Brandeis University</p>
  <div class="classes-container">
    <div class="single_class"
      v-for="cls in Brandeis_classes" :key="cls.index"
    >
    <span  v-html="cls.title"></span>
    <span  v-html="cls.description"></span>
    </div>
  </div>
</div>
</template>

<script>
import {getAllUSCTeachings, getAllBrandeisTeachings} from "../../service/research/teaching";
export default {
  name: "Teaching",
  data(){
    return{
      USC_classes:[],
      Brandeis_classes:[],
    }
  },
  mounted() {
    getAllUSCTeachings()
        .then(content => {
          this.USC_classes = content;
        })
        .catch(err => {
          console.error(err.message);
        });
    getAllBrandeisTeachings()
        .then(content => {
          this.Brandeis_classes = content;
        })
        .catch(err => {
          console.error(err.message);
        });
  },
}
</script>

<style scoped>
.sub-header{
  text-align: center;
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  font-size: 25px;
  margin: 40px;
}
.classes-container{
  width:90%;
  margin-left:auto;
  margin-right: auto;
  display:flex;
  flex-wrap: wrap;
}
.single_class{
  width:50%;
  padding-left:5%;
  padding-right: 5%;
  padding-bottom: 3%;
}
::v-deep a:link {
  /*background-color: yellow;*/
  text-decoration: none;
  font-weight: 600;
  color: black;
}
</style>
